import React from 'react';
import { OptionalHeroRecord } from '~/config/generated/graphql';
import OptionalHero from '~/App/components/OptionalHero';

interface Props {
  data: OptionalHeroRecord;
  isLoading: boolean;
  contentMaxWidth?: number;
}

function BlogHero({ data, contentMaxWidth, isLoading }: Props) {
  return (
    <div>
      <OptionalHero
        data={data}
        contentMaxWidth={contentMaxWidth}
        isLoading={isLoading}
      />
    </div>
  );
}

export default BlogHero;
